<template>
    <div>
        <el-dialog
            title="函询"
            :visible.sync="dialogVisible"
            width="45%"
            :before-close="cancleClick"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
						append-to-body
        >
            <el-form
                class="dialogForm"
                label-position="right"
                label-width="135px"
                :model="formLabelAlign"
                :rules="rules"
                ref="ruleForm"
                @submit.native.prevent
            >
                 <el-form-item label="函询类型：" prop="markType" v-if='isShop'>
                    <div class="typeList">
                        <ul class="clearfix">
                            <li class="fl cursor"
                                v-for="(item,index) in type" :key="index"
                                @click="formLabelAlign.markType = item.val"
                                :class="{'active': formLabelAlign.markType == index + 1}">
                            <span>{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                </el-form-item>
                <el-form-item label="请选择函询类型："  prop="inquiryType" v-else>
                    <el-radio-group  v-model="formLabelAlign.inquiryType" size="medium">
                        <el-radio-button 
                            v-for="(item, index) in typeData"
                            :key="index"
                            :label="item.supervisorType"
                        >{{ item.supervisorTypeName }}</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="疑问事项：" prop="question">
                    <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="请输入最少5个字，最多200字"
                        resize="none"
                        maxlength="200"
                        minlength="5"
                        show-word-limit
                        v-model="formLabelAlign.question"
                        :autosize="{ minRows: 4, maxRows: 8 }"
                    ></el-input>
                </el-form-item>
                <el-form-item label="我的理解：">
                    <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="最多输入200字"
                        resize="none"
                        maxlength="200"
                        show-word-limit
                        v-model="formLabelAlign.comprehend"
                        :autosize="{ minRows: 4, maxRows: 8 }"
                    ></el-input>
                </el-form-item>
                <el-form-item label="请求答复：">
                    <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="最多输入200字"
                        resize="none"
                        maxlength="200"
                        show-word-limit
                        v-model="formLabelAlign.requestAnswer"
                        :autosize="{ minRows: 4, maxRows: 8 }"
                    ></el-input>
                </el-form-item>
                <div class="formLi" v-for="(ele,inx) in formLabelAlign.customFieldList" :key="inx">
                    <div class="liTitle">
                        <el-input
                            v-model="ele.title"
                            maxlength="10"
                            placeholder="请输入内容"
                            class="addInput"
                        ></el-input>
                    </div>
                    <div class="liForm">
                        <el-input
                            type="textarea"
                            :rows="4"
                            placeholder="最多输入200字"
                            v-model="ele.value"
                            maxlength="200"
                            resize="none"
                            show-word-limit
                            :autosize="{ minRows: 4, maxRows: 8 }"
                        ></el-input>
                        <i class="el-icon-remove-outline deleteItemLi" @click="deleteItemLi(inx)"></i>
                    </div>
                </div>

                <el-form-item>
                    <el-button icon="el-icon-plus" @click="addDomain">新增</el-button>
                    <span class="notes">最多新增5个字段，标题最多输入10字，内容最多输入200字</span>
                </el-form-item>
                <el-form-item label="上传附件：" prop="fileList">
                    <el-upload
                        class="upload-demo"
                        :action="uploadUrl"
                        :on-success="handlePreview"
                        :on-remove="handleRemove"
                        :before-upload="beforeUpload"
                        multiple
                        :limit="5"
                        :on-exceed="handleExceed"
                        :file-list="formLabelAlign.fileList"
                        :accept="accepts"
                    >
                        <el-button icon="el-icon-upload2" @click="uploadFileClick($event)">上传文件</el-button>
                        <div
                            slot="tip"
                            class="el-upload__tip"
                        >支持扩展名：.rar .zip .doc .docx .pdf .jpg，最多上传5个文件，每个大小不超过10Mb</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancleClick">取 消</el-button>
                <el-button type="primary"  :disabled="disabled" @click="confirmClick">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            formLabelAlign: {
                inquiryType:'',
	            markType: '',  
                question: "",
                comprehend: "",
                requestAnswer: "",
                customFieldList: [],
                fileList: []
            },
            disabled:false,
            type:[{
                    name:'商品',
                val:1
            },{
                name:'招标',
                val:2
            },{
                name:'竞价',
                val:3
            },{
                name:'租赁',
                val:4
            },{
                name:'集采',
                val:5
            },{
                name:'经营',
                val:6
            },{
                name:'其他',
                val:7
            },],
            rules: {
                inquiryType:[{
                    required: true,
                    message: "请选择函询类型",
                    trigger: "change"
                }],
                markType:[
                    {
                        required: true,
                        message: "请选择函询类型",
                        trigger: "change"
                    }
                ],
                question: [
                    {
                        required: true,
                        message: "请输入最少5个字，最多200字",
                        trigger: "change"
                    },
                    {
                        min: 5,
                        max: 200,
                        message: "长度在 5 到 200 个字符",
                        trigger: "change"
                    }
                ]
            },

            uploadUrl: `${process.env.VUE_APP_API}/old/fileUpload`,
            accepts: ".rar, .zip, .doc, .docx, .pdf, .jpg"
        };
    },
    props: {
        dialogVisible: {
            //控制dialog显示隐藏
            type: Boolean
        },
        dialogType: {
            // 0为招标 1为竞价
            type: Number
        },
        typeData:{
            type: Array,
            default: function() {
                return [];
            }
        },
        isShop:{
            type: Boolean
        },
    },
    methods: {
        clearForm(){
            // alert(`ruleForm`)
            this.formLabelAlign = this.$options.data().formLabelAlign
            // this.disabled = false
            // this.$refs.ruleForm.resetFields()
        },
        cancleClick() {
            this.clearForm();
            this.$emit("closeDialog", false);
        },
        confirmClick() {
            this.$refs["ruleForm"].validate(valid => {
                if (valid) {
                    this.disabled =true;
                    for (
                        let i = 0;
                        i < this.formLabelAlign.customFieldList.length;
                        i++
                    ) {
                        if (
                            !(
                                this.formLabelAlign.customFieldList[i].title &&
                                this.formLabelAlign.customFieldList[i].value
                            )
                        ) {
                            this.$message({
                                type: "warning",
                                message: "新增标题与内容需全部填写"
                            });
                            return;
                        }
                    }
                    let arr = [];
                    for (
                        let i = 0;
                        i < this.formLabelAlign.fileList.length;
                        i++
                    ) {
                        let obj = {
                            name: this.formLabelAlign.fileList[i].name,
                            fileUrl: this.formLabelAlign.fileList[i].response
                        };
                        arr.push(obj);
                    }
                    let dataObj = {
                        ...this.formLabelAlign
                    };
                    dataObj.fileList = arr;
                    this.$emit("confirmDialog", dataObj,() => {
                        this.clearForm();
                        this.disabled = false;
                    });
                } else {
                    return false;
                }
            });
        },
        deleteItemLi(index) {
            this.formLabelAlign.customFieldList.splice(index, 1);
        },
        addDomain() {
            if (this.formLabelAlign.customFieldList.length == 5) {
                this.$message({
                    type: "warning",
                    message: "最多只可以添加五条"
                });
                return;
            }
            this.formLabelAlign.customFieldList.push({
                title: "",
                value: ""
            });
        },
        handleRemove(file, fileList) {
            this.formLabelAlign.fileList = fileList;
        },
        handlePreview(response, file, fileList) {
            this.formLabelAlign.fileList = fileList;
            this.$message({
                message: "文件上传成功",
                type: "success"
            });
        },
        handleExceed(files, fileList) {
            this.$message.warning(
                `当前限制选择 5 个文件，本次选择了 ${
                    files.length
                } 个文件，共选择了 ${files.length + fileList.length} 个文件`
            );
        },
        uploadFileClick(event) {
            if (this.formLabelAlign.fileList.length === 5) {
                this.$message({
                    type: "warning",
                    message: "最多只可以添加五条"
                });
                event.stopPropagation();
                return false;
            }
        },
        beforeUpload(file) {
            var isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message({
                    type: "warning",
                    message: "上传文件大小不能超过 10MB!"
                });
                return false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.typeList{
    ul{
        li{
        width: 70px;
        line-height: 40px;
        text-align: center;
        border: 1px solid #e4e7ed;
        margin-right: 10px;
        &:hover{
            color: #2e90fe;
        }
        &:last-child{
            margin-right: 0 !important;
        }
        }
        .active{
        color: #ffffff;
        background-color: #2e90fe;
        }
    }
}
.dialogForm {
    margin-right: 3%;
}
.formLi {
    clear: both;
    margin-bottom: 15px;
    .liTitle {
        float: left;
        width: 120px;
        overflow: hidden;
        .addInput {
            width: 110px;
        }
    }
    .liForm {
        float: left;
        position: relative;
        width: calc(100% - 120px);
        margin-bottom: 22px;
        .deleteItemLi {
            display: inline-block;
            height: 20px;
            width: 20px;
            font-size: 20px;
            color: red;
            position: absolute;
            z-index: 9;
            top: calc(50% - 10px);
            right: -30px;
            cursor: pointer;
        }
    }
}
.notes {
    margin-left: 10px;
    color: #b4bbc5;
    font-size: 14px;
}
/deep/ .el-form-item {
    clear: both;
}
/deep/ .el-textarea .el-input__count {
    background: none;
}
</style>
